var LoggingLevel = {
  TRACE: 'TRACE',
  DEBUG: 'DEBUG',
  ERROR: 'ERROR',
  INFO: 'INFO',
  WARN: 'WARN'
};
Object.freeze(LoggingLevel);
export default LoggingLevel;